const historyState = (state) => state.history

export const historySelectors = {
    exports: (state) => historyState(state).exports,
    exportsLoading: (state) => historyState(state).exportsLoading,
    exportsError: (state) => historyState(state).exportsError,
    audit: (state) => historyState(state).audit,
    auditLoading: (state) => historyState(state).auditLoading,
    auditError: (state) => historyState(state).auditError,
    versions: (state) => historyState(state).versions,
    maxVersions: (state) => historyState(state).maxVersions,
    versionsLoading: (state) => historyState(state).versionsLoading,
    versionsError: (state) => historyState(state).versionsError,
    versionData: (state) => historyState(state).versionData,
    versionDataLoading: (state) => historyState(state).versionDataLoading,
    versionDataError: (state) => historyState(state).versionDataError,
    generating: (state) => historyState(state).generating,
    notice: (state) => historyState(state).notice,
    error: (state) => historyState(state).error,
}
